export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  highlights: string[];
  articleIds: string[];
  relatedTopicIds: string[];
}

export const topics: Topic[] = [
  {
    id: "jazz-century",
    title: "爵士百年",
    subtitle: "一种声音的全球旅程",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20moody%20abstract%20jazz%20stage%20with%20brass%20instruments%20and%20amber%20spotlight%20beams%2C%20rich%20brown%20and%20gold%20tones%2C%20smoky%20nostalgic%20atmosphere%2C%20cinematic%20artistic%20composition%2C%20editorial%20photography&width=1600&height=900&seq=topic-jazz-cover&orientation=landscape",
    intro:
      "从新奥尔良的街头到世界各地的舞台，爵士乐用一百年时间证明，即兴与对话可以成为一种通用的语言。本专题汇集爵士乐的历史脉络、关键转折与当代回响，带你听懂声音背后的故事。",
    highlights: [
      "梳理爵士乐从地方声音到全球语言的完整路径",
      "解读即兴演奏作为一种对话与态度",
      "收录节奏、器乐与文化语境的关系",
    ],
    articleIds: ["jazz-century", "african-drums", "soul-funk"],
    relatedTopicIds: ["hiphop-culture", "black-art-power"],
  },
  {
    id: "civil-rights",
    title: "民权运动影像志",
    subtitle: "记录改变历史的瞬间",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20sepia%20abstract%20archival%20collage%20of%20old%20photographs%20and%20documents%20layered%20on%20textured%20paper%2C%20golden%20brown%20tones%2C%20historic%20nostalgic%20aesthetic%2C%20artistic%20composition%2C%20editorial%20photography&width=1600&height=900&seq=topic-civil-cover&orientation=landscape",
    intro:
      "文化觉醒与政治抗争从来彼此交织。本专题通过文学、艺术与历史的多个切面，回望那段重新定义尊严与权利的时代，并思考它对今天的意义。",
    highlights: [
      "从哈莱姆文艺复兴看文化自觉的起源",
      "文化表达如何为政治行动提供语言",
      "被遗忘的创造者与他们的贡献",
    ],
    articleIds: ["harlem-renaissance", "forgotten-inventors", "modern-literature"],
    relatedTopicIds: ["black-art-power", "hiphop-culture"],
  },
  {
    id: "black-art-power",
    title: "非裔艺术力量",
    subtitle: "视觉语言的持续生长",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20modern%20art%20studio%20with%20colorful%20canvases%20and%20mixed%20materials%2C%20soft%20warm%20light%2C%20rich%20brown%20and%20orange%20tones%2C%20minimal%20elegant%20artistic%20composition%2C%20editorial%20photography&width=1600&height=900&seq=topic-art-cover&orientation=landscape",
    intro:
      "绘画、纺织、拼贴与舞蹈，非裔艺术家用多样的媒介回应身份、记忆与权力。本专题聚焦当代视觉与身体艺术，观察一种表达如何持续拓展它的边界。",
    highlights: [
      "当代绘画与装置中的身份表达",
      "被低估的手工艺如何走向美术馆中央",
      "身体与舞蹈作为一种政治语言",
    ],
    articleIds: ["contemporary-artists", "textile-identity", "dance-body-politics"],
    relatedTopicIds: ["jazz-century", "civil-rights"],
  },
  {
    id: "hiphop-culture",
    title: "嘻哈文化五十年",
    subtitle: "从街区派对到全球青年文化",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20urban%20rooftop%20at%20dusk%20with%20graffiti%20walls%20and%20orange%20sunset%20light%2C%20rich%20brown%20and%20amber%20tones%2C%20urban%20nostalgic%20aesthetic%2C%20cinematic%20artistic%20composition%2C%20editorial%20photography&width=1600&height=900&seq=topic-hiphop-cover&orientation=landscape",
    intro:
      "嘻哈不只是音乐类型，而是一整套关于表达、自信与生存的文化。本专题回顾它五十年的演进，从布朗克斯的街区派对到遍布全球的年轻声音。",
    highlights: [
      "嘻哈四大元素的起源与交织",
      "说唱如何成为讲述处境的工具",
      "节奏文化对社会表达的影响",
    ],
    articleIds: ["hiphop-fifty", "soul-funk", "language-identity"],
    relatedTopicIds: ["jazz-century", "civil-rights"],
  },
];

export const topicMap: Record<string, Topic> = topics.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {} as Record<string, Topic>);